<template>
    <div>
        <img :src="bannerSrc" class="w-100 pt-4" data-aos="zoom-in" />
        <HomeHowItWorks />
        <HomeFinds />
        <HomePricing />
        <HomeContact />
        <HomeBottom />
    </div>
</template>
<script>
import AOS from "aos";
import HomeFinds from "./HomeFinds.vue";
import HomeContact from "./HomeContact.vue";
import HomeBottom from "./HomeBottom.vue";
export default {
    components: { HomeFinds, HomeContact, HomeBottom },
    data() {
        const banners = [
            "/images/banner1.jpg",
            "/images/banner2.jpg",
            "/images/banner3.jpg",
        ];

        return {
            bannerSrc: banners[Math.floor(Math.random() * banners.length)],
        };
    },
    mounted() {
        AOS.init();
    },
};
</script>
